
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import PilotApplicationForm from "./PilotApplicationForm";

interface ContributeApplicationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onFormSubmitted?: () => void;
}

export function ContributeApplicationDialog({
  open,
  onOpenChange,
  onFormSubmitted,
}: ContributeApplicationDialogProps) {
  const handleFormClose = () => {
    onOpenChange(false);
  };
  
  const handleFormSubmit = () => {
    if (onFormSubmitted) {
      onFormSubmitted();
    }
    onOpenChange(false);
  };
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px] md:max-w-[700px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="sr-only">Contribute Application Form</DialogTitle>
        </DialogHeader>
        <PilotApplicationForm 
          onClose={handleFormClose}
          onSubmitSuccess={handleFormSubmit}
          formTitle="Contribute to the Framework!"
          formDescription="Help us to put up a structured framework for AI inclusion - Inputs & Outputs"
          formType="contribute"
        />
      </DialogContent>
    </Dialog>
  );
}

export default ContributeApplicationDialog;
